import { render, staticRenderFns } from "./NowhowRadioYesNo.vue?vue&type=template&id=1efce629"
import script from "./NowhowRadioYesNo.vue?vue&type=script&lang=ts"
export * from "./NowhowRadioYesNo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports